import * as React from 'react';
import * as queryString from 'qs';

import { Link, useLocation } from 'react-router-dom';

import s from './pagination.css';

const MAX_PAGES = 7;

interface IProps {
  searchTag?: string;
  pagesCount: number;
  activePage: number;
  getMoreItems: any;
  showMoreBtn: boolean;
  search?: string;
}

interface IPages {
  text: string;
  value: number;
}

export const Pagination: React.FC<IProps> = props => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const ordering = query.get('ordering') ? (query.get('ordering') as string) : '-date_publish';

  function pages(): IPages[] {
    const { pagesCount, activePage } = props;
    const pages: IPages[] = [
      {
        text: '1',
        value: 1,
      },
    ];
    let start = 2;

    if (activePage - MAX_PAGES > 1) {
      start = activePage - MAX_PAGES + 1;
      pages.push({
        text: '...',
        value: start - 1,
      });
    }

    for (let i = start; i <= pagesCount; i++) {
      if (i > activePage + MAX_PAGES + 1) {
        pages.push({
          text: '...',
          value: i,
        });
        break;
      }

      pages.push({
        text: '' + i,
        value: i,
      });
    }

    return pages;
  }

  function pathname(): string {
    const { pathname } = location;

    return pathname.replace(/\/content/g, '');
  }

  const getMore = (event: any) => {
    const { searchTag, activePage, getMoreItems } = props;

    event.target.blur();

    window.history.pushState(
      '',
      '',
      `${location.pathname}?${queryString.stringify(
        {
          page: activePage + 2,
          tag: searchTag ? searchTag : null,
          ordering,
          author_id: query.get('author_id'),
          search: search ? search : null,
          comment_user_id: query.get('comment_user_id'),
        },
        { skipNulls: true },
      )}`,
    );
    getMoreItems(activePage + 2);
  };

  const { searchTag, activePage, pagesCount, showMoreBtn, search } = props;

  return (
    <div className={s['pagination__more-btn']}>
      {showMoreBtn && activePage < pagesCount - 1 && (
        <div role="button" className={s['more-btn']} onClick={getMore}>
          Показать ещё
        </div>
      )}
      <div className={s['paging']}>
        {pages().map(({ text, value }, i) => {
          if (activePage + 1 === value) {
            return (
              <span key={`page-${i}`} className={s['paging__active-text']}>
                {' '}
                {text}{' '}
              </span>
            );
          }

          return (
            <Link
              className={s['paging__link']}
              key={`page-${i}`}
              to={{
                pathname: pathname(),
                search: `${queryString.stringify(
                  {
                    page: value,
                    tag: searchTag ? searchTag : null,
                    ordering,
                    author_id: query.get('author_id'),
                    search: search ? search : null,
                    comment_user_id: query.get('comment_user_id'),
                  },
                  { skipNulls: true },
                )}`,
              }}
            >
              {text}
            </Link>
          );
        })}
      </div>
    </div>
  );
};
